module.exports = __webpack_public_path__ + "9e2020d2ec41ef3e693161b637479d56.svg";